import { createI18n } from 'vue-i18n';

const messages = {
  en: {
    login: 'Sign in',
    signInLead: 'Sign in to find your season and collect looks in one place.',
    noAccount: 'No account?',
    signUpLead: 'Create an account to find your season and collect looks in one place.',
    haveAccount: 'Already have an account?',
    email: 'Email',
    password: 'Password',
    confirmPassword: 'Confirm password',
    firstName: 'First name',
    lastName: 'Last name',
    forgot: 'Forgot',
    userName: 'Username',
    incorrectLoginPassword: 'Incorrect login or password',
    userNotFound: 'User not found',
    validation: {
      required: 'This field is required',
      email: 'Invalid email address',
      min: 'Minimum {count} characters',
      passwordsMatch: 'The passwords did not match',
      invalidDate: 'Invalid date',
    },
    masks: 'Masks',
    typeMasks: 'Type of masks',
    gallery: 'Gallery',
    upload: 'Upload',
    uploadImage: 'Upload a photo',
    mask: 'Mask',
    collage: 'Collage',
    logout: 'Logout',
    saveToGallery: 'Save to gallery',
    download: 'Download',
    addSign: 'Add Sign',
    shareImageWithCollage: 'Share image with collage',
    shareImageWithMask: 'Share image with mask',
    rememberChoose: 'Remember choose',
    successImage: 'Photo saved to gallery',
    successUpdateFolder: 'Update folder',
    errorImage: 'Error image uploaded',
    addFolder: 'Add folder',
    delete: 'Delete',
    newFolder: 'New folder',
    nameFolder: 'name folder',
    choose: 'Choose',
    chooseAll: 'Choose all',
    edit: 'Edit',
    cancel: 'Cancel',
    ok: 'Ок',
    search: 'search',
    dywDelete: 'Do you want delete 1 element?',
    dyrAllDeleted: 'Do you really want to delete the selected items?',
    clear: 'Clear',
    apply: 'Apply',
    folder: 'Folder',
    total: 'Total',
    photo: 'Photo',
    update: 'Update',
    copyLink: 'Copy link',
    noName: 'No name',
    pickPhoto: 'Pick a photo',
    successFolderCreate: 'Create folder',
    successDeleteFolder: 'Delete folder',
    successDeleteImage: 'Delete image',
    successDeleteImages: 'Delete images',
    successUpdateImage: 'Update image',
    unknownError: 'Unknown error',
    takePhoto: 'Take a photo',
    characteristicColor: 'Colors',
    photoNotUploaded: 'Photo not uploaded',
    combinations: 'Combinations',
    scale: 'Scale',
    home: 'Home',
    signUp: 'Sign up',
    birthDate: 'Date of birth',
    birthDateMask: 'DD.MM.YYYY',
    emailExists: 'Email already exists!',
    profile: 'Profile',
    confirmation: 'Confirmation',
    writeSomething: 'Write something.....',
    aiAgent: 'AI agent',
    greedyAI:
      'Hello, I’d be glad to help you with any question! Would you like me to identify the colors in a photo? Just upload it and I’ll assist you.',
    reminderPickColor:
      'For a more accurate palette definition, please fill in all the squares with colors!',
    palette: 'Palette',
    define: 'Define',
    top3: 'Top 3 possible palettes',
    softSummerPalette: 'Soft Summer — soft and cold palette',
    darkAutumnPalette: 'Dark Autumn — warm and dark palette',
    coldSummerPalette: 'Cold Summer — cold and soft palette',
    lightSpringPalette: 'Light Spring — light and warm palette',
    softAutumnPalette: 'Soft Autumn — soft and warm palette',
    brightSpringPalette: 'Bright Spring — bright and warm palette',
    warmSpringPalette: 'Warm Spring — warm and bright palette',
    darkWinterPalette: 'Dark Winter — dark and cold palette',
    lightSummerPalette: 'Light Summer — light and cold palette',
    warmAutumnPalette: 'Warm Autumn — warm and soft palette',
    coldWinterPalette: 'Cold Winter — cold and bright palette',
    brightWinterPalette: 'Bright Winter — bright and cold palette',
    softSummerPaletteShort: 'Soft Summer',
    darkAutumnPaletteShort: 'Dark Autumn',
    coldSummerPaletteShort: 'Cold Summer',
    lightSpringPaletteShort: 'Light Spring',
    softAutumnPaletteShort: 'Soft Autumn',
    brightSpringPaletteShort: 'Bright Spring',
    warmSpringPaletteShort: 'Warm Spring',
    darkWinterPaletteShort: 'Dark Winter',
    lightSummerPaletteShort: 'Light Summer',
    warmAutumnPaletteShort: 'Warm Autumn',
    coldWinterPaletteShort: 'Cold Winter',
    brightWinterPaletteShort: 'Bright Winter',
    cold: 'Cold',
    warm: 'Warm',
    dark: 'Dark',
    light: 'Light',
    mute: 'Mute',
    bright: 'Bright',
    seeMore: 'See more',
    welcomeText: 'Welcome to Your Personal Color Guide',
    welcomeSubText:
      'Take a photo, find your Sci Art season, and wear colors that actually suit you.',
    homeFeaturePhotoTitle: 'Photo analysis',
    homeFeaturePhotoText:
      'Warmth, chroma, and value from a portrait in frame or a photo on your phone.',
    homeFeaturePalettesTitle: '12 Sci Art palettes',
    homeFeaturePalettesText:
      'Soft Summer through Bright Winter — full seasonal color sets, ready to try on.',
    homeFeatureAiTitle: 'AI colorist',
    homeFeatureAiText:
      'Ask which colors suit you, recolor clothes on a photo, and try the look in your season.',
    homeFeatureGalleryTitle: 'Gallery and lookbooks',
    homeFeatureGalleryText:
      'Save shots by palette, folder, and notes — then find them again and turn them into a lookbook.',
    homeFeatureGallerySearch: 'Search and filter by season, mask, or folder',
    homeFeatureGalleryLookbook: 'Build lookbooks from saved photos',
    homeFeatureGalleryPdf: 'Export a lookbook as PDF for print or a client',
    homeLooksTitle: 'Looks from the palettes',
    homeLookChips: 'Palette cards',
    homeLookBaseAccent: 'Base and accents',
    homeLookMapped: 'Colors from the look',
    homeAiRecolorTitle: 'Transform with AI',
    homeAiRecolorText:
      'Change a sweater, trousers, or the whole look to your season. Skin, light, and fabric stay in place.',
    homeAiRecolorBefore: 'Original',
    homeAiRecolorAfter: 'AI recolor',
    homeFramesTitle: 'Portrait in a palette frame',
    homeFramesText: 'Twelve Sci Art colors around the face: cold, warm, dark, light, mute, bright.',
    homeStockLooksKicker: 'Reference looks',
    homeStockLooksTitle: 'Looks by color',
    homeStockLooksText:
      'Search ready outfits by your season or a color from the photo — Pexels and Unsplash in one place.',
    homeStockLookStylist: 'Stylist',
    homeStockLookStudio: 'Studio',
    homeStockLookColorist: 'Colorist',
    whoIsThisAppFor: 'Who Is This App For?',
    discoverColorText: 'Discover how this app empowers your color journey.',
    individualReadyText:
      'Individuals ready to unlock the power of color in their personal style journey.',
    fashionLoversText: 'Fashion lovers seeking clarity and confidence in every outfit choice.',
    designersCravingText:
      'Stylists  and colorists  craving palettes that spark creativity and harmony.',
    curiosMindText: 'Curious minds exploring the science and emotion behind color aesthetics.',
    getStarted: 'Start Your Color Journey',
    instantFramedPhotos: 'Instant Framed Photos',
    capturePhotoText:
      'Determine the dominant characteristic of color warmth - coolness; brightness - softness; lightness - darkness. Upload a photo from your device or take a picture within the desired frame directly in the application. Save photos to the gallery using customizable folders and caption options.',
    paletteExplorerText: 'Palette Explorer',
    paletteExplorerSubText: 'The section includes 12 palettes from the Sci Art tonal system',
    homePaletteChoice: 'Which one is yours?',
    homeSeasonPreviewMore: 'View all frames',
    homeSeasonWarmAutumnTrait: 'Warm, muted, earthy',
    homeSeasonBrightWinterTrait: 'Cool, high contrast, jewel',
    homeSeasonLightSpringTrait: 'Warm, clear, fresh',
    homeSeasonSoftSummerTrait: 'Cool, soft, misty',
    homeStudioTitle: 'Studio tools, not guesswork',
    homeStudioText:
      'Everything you need to diagnose, dress, and recolor — from consultation to closet.',
    homeStudioAnalysisTitle: 'Season analysis',
    homeStudioAnalysisText:
      'Map undertone, contrast, and chroma into a clear seasonal palette your clients can trust.',
    homeStudioWardrobeTitle: 'Wardrobe mapping',
    homeStudioWardrobeText:
      'Score pieces against your season, spot gaps, and build looks that already live in the closet.',
    homeStudioRecolorTitle: 'Studio recolor',
    homeStudioRecolorText:
      'AI shifts fabrics into flattering hues so fittings happen on screen before the rack.',
    selectAnyColorsText: 'Pick up any color from your photo.',
    optionalColorChromaText: 'Get optimal matching colors using Chroma.js.',
    buildPaletteText: 'Find out your optimal palette from five chosen tones.',
    askQuestionAiText: 'Ask questions, get guidance, and explore seasonal palettes.',
    learnPreferColorText: 'Learn which color types suit your undertones and preferences.',
    afterAllText: 'After all, you can talk to him about absolutely anything.',
    yourGallery: 'Your Gallery',
    organizeGalleryText: 'Organize, explore, and relive your memories with ease.',
    allYourPhotoText: 'All your saved photos in one place',
    searchGalleryText: 'Search and filter by palette type, masks, or folders',
    storedText: 'Stored securely via Firebase',
    canInstall: 'You can install this app on your phone or computer as',
    detailInstructions: 'For detailed instructions, please visit the section',
    FAQ: 'FAQ',
    faqLead: 'Install Rainbow Manager on your phone like a regular app.',
    installPWATitle: 'Installing the app as a PWA',
    howInstallIOSTitle: 'How to install the app on iOS?',
    howInstallAndroidTitle: 'How to install the app on Android?',
    openAppInBrowserTitle: 'Open the application in your browser',
    pressBtnTitle: 'Click on the button',
    selectItem: 'Select an item',
    squareIconTitle: 'square icon with an up arrow',
    confirmAndClickTitle: 'Confirm the name and click',
    appWillAppearText: 'The app icon will now appear on your home screen like a regular app.',
    threeDotsText: 'three dots in the upper right corner',
    addToHomeScreenTitle: 'Add to Home Screen',
    addToHomeScreenIosTitle: 'Add to Home Screen',
    addTitle: 'Install',
    contacts: 'Contacts',
    contactsLead: 'Write us if you have an idea, a question, or need help with the app.',
    ideaAndSuggestions: 'Ideas and suggestions',
    supportAndAssistance: 'Support and assistance',
    privacyPolicy: 'Privacy policy',
    termsOfService: 'Terms of Service',
    legalAgreeLead: 'By creating an account you agree to the',
    legalAgreeAnd: 'and the',
    accountDeleteTitle: 'Delete your account',
    accountDeleteIntro:
      'Request the deletion of your Rainbow Manager account and everything stored with it. You can do this here or in the mobile app under Account.',
    accountDeleteWhatTitle: 'What gets deleted',
    accountDeleteWhatProfile: 'Your profile and sign-in credentials',
    accountDeleteWhatGallery: 'Photos, folders, palettes and lookbooks, including their files',
    accountDeleteWhatChats: 'AI chats with their attached and generated images',
    accountDeleteWhatUsage:
      'Usage counters, purchase records and support history tied to the account',
    accountDeleteKeepTitle: 'What stays',
    accountDeleteKeepStore:
      'Deleting the account does not cancel a subscription bought in Google Play or the App Store. Cancel it in the store, otherwise billing continues. Payment receipts are kept by the store, not by us.',
    accountDeleteSignedInAs: 'Signed in as {email}',
    accountDeleteAction: 'Delete account',
    accountDeleteConfirmQuestion: 'Delete the account and all of its data? This cannot be undone.',
    accountDeleteConfirmAction: 'Yes, delete',
    accountDeleteCancel: 'Cancel',
    accountDeleteSignInFirst: 'Sign in with the account you want to delete.',
    accountDeleteSignIn: 'Sign in',
    accountDeleteDoneTitle: 'The account has been deleted',
    accountDeleteDoneText:
      'Your account and its data are gone. Cancel the store subscription if you had one.',
    accountDeleteError: 'The account was not deleted. Please try again or write to support.',
    accountDeleteNoAccessTitle: 'Cannot sign in?',
    accountDeleteNoAccessText:
      'Write to {email} from the address of the account. We reply to the address registered on the account and delete it only after you confirm, so a request naming somebody else leads nowhere.',
    resetPassword: 'Reset your password',
    forgotLead: 'Enter your email and we will send a link to reset the password.',
    send: 'Send',
    goBack: 'Go Back',
    passwordResetEmailSent: 'Password reset email sent',
    registrationSuccessful: 'Registration was successful!',
    nextStep: 'Next step',
    characteristicColors: 'Characteristic colors',
    paletteDeterminant: 'Palette determinant',
    settings: 'Settings',
    fullFill: 'Full palette',
    showOnlySoft: 'Show only soft ones',
    showOnlyBright: 'Show only bright ones',
    showOnlyCold: 'Show only cold ones',
    showOnlyWarm: 'Show only warm ones',
    showOnlyLight: 'Show only light ones',
    showOnlyDark: 'Show only dark ones',
    pleaseSelectAtLeastOneCharacteristic: 'Select at least one characteristic!',
    filter: 'Filter',
    myPalette: 'My palette',
    numberOfSegments: 'Number of segments',
    consultation: 'Consultation',
    close: 'Close',
    revealYourInherentElegance: 'Reveal your inherent elegance',
    haveYouEverContemplated: 'Have you ever contemplated',
    whyCertainHues:
      'why certain hues illuminate your presence while others render you virtually imperceptible?',
    greedy:
      "I'm Julia, and I understand that each of us possesses a unique color palette bestowed by nature — one that can unveil our innate beauty and instill profound confidence.",
    myGoal:
      'My purpose is to guide you in discovering that palette through the art of personal color analysis!',
    whatWilGain: 'What will you gain by determining your color season?',
    recoveredTime: 'Recovered time and conserved capital',
    youWillCeaseAcquiring:
      'You will cease acquiring garments destined to languish unworn in your wardrobe.',
    assuredSelection: 'Assured selection',
    youWillPossessPreciseClarity:
      'You will possess precise clarity on which shades to select whether shopping for attire refining your makeup palette or coloring your hair.',
    cohesiveHarmonious: 'A cohesive and harmonious presentation',
    youWillAppearMore:
      'You will appear more refreshed and expressive. Every element of your wardrobe will harmonize seamlessly.',
    bidFarewell: 'Bid farewell to compromises and ceaseless experimentation!',
    togetherWeWillDiscover:
      'Together we will discover the colors that will actively enhance your presence!',
    connectViaTelegram: 'Connect via Telegram',
    demoLookbook: 'Demo lookbook',
    remainingInquiries: 'Remaining inquiries? Schedule your consultation.',
    loginSuccessful: 'Login successful!',
    loginWithGoogle: 'Login with Google',
    popupClosedByUser: 'Popup closed by user',
    cancelled: 'Cancelled',
    noResults: 'No results were found for your query!',
    galleryEmpty:
      'Your gallery space currently stands vacant yet it awaits transformation into the canvas for your creative vision.' +
      'Begin by archiving your photographic captures within the gallery and you will unlock access to sophisticated collage creation tools seamlessly interconnect moments experiment with compositional forms and breathe new life into memories through compelling visual narratives.',
    maximumSelectedCollage:
      'A maximum of six photographs may be selected for inclusion in a collage!',
    noFolders: 'Folders have not been created yet!',
    reCAPTCHAInitializationError: 'reCAPTCHA Initialization Error',
    reCAPTCHAHasExpired: 'reCAPTCHA has expired. Please complete the verification again.',
    linkCopied: 'Link copied!',
    copyError: 'Copy error!',
    colorCopied: 'Color copied!',
    mainColor: 'Main color',
    save: 'Save',
    successPaletteTemplateCreate: 'The template was successfully saved!',
    addTemplate: 'Add template',
    successUpdatePaletteTemplate: 'Template updated successfully!',
    successDeletePaletteTemplate: 'Template deleted successfully!',
    template: 'Template',
    myTemplates: 'My templates',
    resetTemplate: 'Reset template',
    updateTemplate: 'Update template',
    analysisByPhoto: 'Analysis by photo',
    saveChanges: 'Save changes',
    reset: 'Reset',
    next: 'Next',
    selectTopColors: 'Please select the top colors',
    selectOneColor: 'Please select at least one color!',
    shapeOfElements: 'Shape of elements',
    transformation: 'Transformation',
    shadowSettings: 'Shadow settings',
    enableShadow: 'Enable shadow',
    intensity: 'Intensity',
    yOffset: 'Y offset',
    transparency: 'Transparency',
    arrangementElements: 'Arrangement of elements',
    columns: 'Columns',
    rows: 'Rows',
    autoSelection: 'Auto selection',
    auto: 'Auto',
    colors: 'Colors',
    of: 'of',
    grid: 'Grid',
    sizingSettings: 'Sizing settings',
    elementSize: 'Element size',
    spaceBetweenElements: 'Space between elements',
    cutPalette: 'Cut palette',
    pickColor: 'Pick color',
  },
  ru: {
    login: 'Вход',
    signInLead: 'Войдите, чтобы определить сезон и собрать образы в одном месте.',
    noAccount: 'Нет аккаунта?',
    signUpLead: 'Создайте аккаунт, чтобы определить сезон и собрать образы в одном месте.',
    haveAccount: 'Уже есть аккаунт?',
    email: 'Почта',
    password: 'Пароль',
    confirmPassword: 'Повторите пароль',
    firstName: 'Имя',
    lastName: 'Фамилия',
    forgot: 'Забыли',
    userName: 'Имя пользователя',
    incorrectLoginPassword: 'Неверный логин или пароль',
    userNotFound: 'Пользователь не найден',
    validation: {
      required: 'Поле обязательно для заполнения',
      email: 'Некорректный email',
      min: 'Минимум {count} символов',
      passwordsMatch: 'Пароли не совпали',
      invalidDate: 'Неверный формат',
    },
    masks: 'Маски',
    gallery: 'Галерея',
    upload: 'Загрузить',
    uploadImage: 'Загрузите фотографию',
    mask: 'Маска',
    collage: 'Коллаж',
    logout: 'Выйти',
    saveToGallery: 'Сохранить в галерею',
    download: 'Скачать',
    addSign: 'Добавить подпись',
    shareImageWithCollage: 'Показывать в коллаже',
    shareImageWithMask: 'Показывать в маске',
    rememberChoose: 'Запомнить',
    successImage: 'Фото сохранено в галерею',
    errorImage: 'Ошибка при загрузке изображения',
    addFolder: 'Добавить папку',
    delete: 'Удалить',
    newFolder: 'Новая папка',
    choose: 'Выбрать',
    chooseAll: 'Выбрать все',
    edit: 'Исправить',
    cancel: 'Отменить',
    ok: 'Ок',
    search: 'поиск',
    nameFolder: 'название папки',
    dywDelete: 'Удалить 1 элемент?',
    dyrAllDeleted: 'Вы уверены, что хотите удалить выбранные элементы?',
    clear: 'Очистить',
    apply: 'Применить',
    folder: 'Папка',
    total: 'Всего',
    photo: 'Фото',
    update: 'Обновить',
    copyLink: 'Скопировать ссылку',
    noName: 'Без названия',
    pickPhoto: 'Выберите фото',
    successFolderCreate: 'Папка добавлена',
    successDeleteFolder: 'Папка удалена',
    successUpdateFolder: 'Папка обновлена',
    successDeleteImage: 'Фотография удалена',
    successDeleteImages: 'Фотографии удалены',
    successUpdateImage: 'Фотография обновлена',
    unknownError: 'Неизвестная ошибка',
    takePhoto: 'Фото',
    characteristicColor: 'Цвета',
    photoNotUploaded: 'Фото не загружено',
    combinations: 'Сочетание',
    scale: 'Шкала',
    home: 'Главная',
    signUp: 'Регистрация',
    birthDate: 'Дата рождения',
    birthDateMask: 'DD.MM.YYYY',
    emailExists: 'Такой email уже существует!',
    profile: 'Профиль',
    confirmation: 'Подтверждение',
    writeSomething: 'Напишите что-нибудь.....',
    typeMasks: 'Вид масок',
    aiAgent: 'ИИ агент',
    greedyAI:
      'Привет, буду рад тебе помочь с любым вопросом! Хочешь определим цвета в фотографии? Просто загрузи ее и я помогу!',
    reminderPickColor: 'Для более точного определения палитры заполните все квадраты цветом!',
    palette: 'Палитра',
    define: 'Определить',
    top3: 'Топ 3 вероятных палитры',
    softSummerPalette: 'Мягкое лето — мягкий и холодный колорит',
    darkAutumnPalette: 'Тёмная осень — тёплый и тёмный колорит',
    coldSummerPalette: 'Холодное лето — холодный и мягкий колорит',
    lightSpringPalette: 'Светлая весна — светлый и тёплый колорит',
    softAutumnPalette: 'Мягкая осень — мягкий и тёплый колорит',
    brightSpringPalette: 'Яркая весна — яркий и тёплый колорит',
    warmSpringPalette: 'Тёплая весна — тёплый и яркий колорит',
    darkWinterPalette: 'Тёмная зима — тёмный и холодный колорит',
    lightSummerPalette: 'Светлое лето — светлый и холодный колорит',
    warmAutumnPalette: 'Тёплая осень — тёплый и мягкий колорит',
    coldWinterPalette: 'Холодная зима — холодный и яркий колорит',
    brightWinterPalette: 'Яркая зима — яркий и холодный колорит',
    softSummerPaletteShort: 'Мягкое лето',
    darkAutumnPaletteShort: 'Тёмная осень',
    coldSummerPaletteShort: 'Холодное лето',
    lightSpringPaletteShort: 'Светлая весна',
    softAutumnPaletteShort: 'Мягкая осень',
    brightSpringPaletteShort: 'Яркая весна',
    warmSpringPaletteShort: 'Тёплая весна',
    darkWinterPaletteShort: 'Тёмная зима',
    lightSummerPaletteShort: 'Светлое лето',
    warmAutumnPaletteShort: 'Тёплая осень',
    coldWinterPaletteShort: 'Холодная зима',
    brightWinterPaletteShort: 'Яркая зима',
    cold: 'Холодный',
    warm: 'Теплый',
    dark: 'Темный',
    light: 'Светлый',
    mute: 'Мягкий',
    bright: 'Яркий',
    seeMore: 'Увидеть больше',
    welcomeText: 'Добро пожаловать в ваш персональный цветовой гид!',
    welcomeSubText:
      'Сфотографируйтесь, найдите свой сезон Sci Art и носите цвета, которые вам действительно идут.',
    homeFeaturePhotoTitle: 'Анализ по фото',
    homeFeaturePhotoText:
      'Теплота, яркость и светлота — по портрету в рамке или снимку с телефона.',
    homeFeaturePalettesTitle: '12 палитр Sci Art',
    homeFeaturePalettesText: 'От мягкого лета до яркой зимы — готовые сезонные наборы оттенков.',
    homeFeatureAiTitle: 'AI-колорист',
    homeFeatureAiText:
      'Спросите, какие цвета вам идут, перекрасьте одежду на фото и примерьте образ в своём сезоне.',
    homeFeatureGalleryTitle: 'Галерея и лукбуки',
    homeFeatureGalleryText:
      'Сохраняйте кадры по палитре, папкам и подписям — потом найдёте нужное и соберёте лукбук.',
    homeFeatureGallerySearch: 'Поиск и фильтр по сезону, маске или папке',
    homeFeatureGalleryLookbook: 'Лукбуки из сохранённых кадров',
    homeFeatureGalleryPdf: 'PDF лукбука для печати или клиента',
    homeLooksTitle: 'Образы из палитр',
    homeLookChips: 'Карточки палитры',
    homeLookBaseAccent: 'База и акценты',
    homeLookMapped: 'Цвета с образа',
    homeAiRecolorTitle: 'Трансформация с AI',
    homeAiRecolorText:
      'Меняйте цвет свитера, брюк или всего образа под свой сезон. Кожа, свет и фактура ткани остаются на месте.',
    homeAiRecolorBefore: 'Было',
    homeAiRecolorAfter: 'Стало',
    homeFramesTitle: 'Портрет в рамке палитры',
    homeFramesText:
      'Двенадцать цветов Sci Art вокруг лица: холодный, тёплый, тёмный, светлый, мягкий, яркий.',
    homeStockLooksKicker: 'Референсы',
    homeStockLooksTitle: 'Образы по цвету',
    homeStockLooksText:
      'Ищите готовые луки по сезону или цвету с фото — Pexels и Unsplash в одном месте.',
    homeStockLookStylist: 'Стилист',
    homeStockLookStudio: 'Студия',
    homeStockLookColorist: 'Колорист',
    whoIsThisAppFor: 'Для кого это приложение?',
    discoverColorText: 'Узнайте, как это приложение поможет вам в вашем путешествии по миру цвета.',
    individualReadyText: 'Для тех, кто готов раскрыть потенциал цвета в своем личном стиле.',
    fashionLoversText: 'Любители моды, стремящиеся к ясности и уверенности в каждом выборе наряда.',
    designersCravingText:
      'Стилисты и колористы стремящиеся к цветовым палитрам, которые пробуждают творчество и гармонию.',
    curiosMindText: 'Любознательные умы изучающие научные и эмоциональные аспекты эстетики цвета.',
    getStarted: 'Начните цветовое путешествие',
    instantFramedPhotos: 'Фотографии в рамках',
    capturePhotoText:
      'Определите ведущую характеристику цвета: теплота - холод; яркость - мягкость; светлота - темнота. ' +
      'Загружайте фотографию со своего устройства или делайте фото в нужной рамке прямо в приложении. Сохраняйте фотографии в галерею, используя настраиваемые папки и параметры подписи',
    paletteExplorerText: 'Палитры',
    paletteExplorerSubText: 'Раздел включает 12 палитр тоновой системы Sci Art',
    homePaletteChoice: 'Какая подходит',
    homeSeasonPreviewMore: 'Смотреть все фреймы',
    homeSeasonWarmAutumnTrait: 'Тёплый, приглушённый, землистый',
    homeSeasonBrightWinterTrait: 'Холодный, контрастный, драгоценный',
    homeSeasonLightSpringTrait: 'Тёплый, чистый, свежий',
    homeSeasonSoftSummerTrait: 'Холодный, мягкий, туманный',
    homeStudioTitle: 'Инструменты студии, не гадание',
    homeStudioText:
      'Всё, чтобы определить сезон, собрать гардероб и перекрасить образ — от консультации до шкафа.',
    homeStudioAnalysisTitle: 'Анализ сезона',
    homeStudioAnalysisText:
      'Теплота, контраст и чистота цвета — в понятную сезонную палитру, которой можно доверять.',
    homeStudioWardrobeTitle: 'Карта гардероба',
    homeStudioWardrobeText:
      'Сверяйте вещи с сезоном, находите пробелы и собирайте луки из того, что уже есть в шкафу.',
    homeStudioRecolorTitle: 'Студийная перекраска',
    homeStudioRecolorText:
      'AI переносит ткани в подходящие оттенки — примерка на экране, до вешалки.',
    selectAnyColorsText: 'Выберите любой цвет с вашей фотографии.',
    optionalColorChromaText: 'Получите оптимальное соответствие цветов с помощью Chroma.js.',
    buildPaletteText: 'Узнайте свою оптимальную палитру по пяти выбранным оттенкам.',
    askQuestionAiText:
      'Задавайте вопросы, получайте рекомендации и изучайте сезонные цветовые решения.',
    learnPreferColorText: 'Узнайте, какие оттенки подходят именно вам и вашим предпочтениям.',
    afterAllText: 'В конце концов с ним можно обсудить любую тему.',
    yourGallery: 'Твоя галерея',
    organizeGalleryText:
      'С легкостью систематизируйте, изучайте и переживайте заново свои воспоминания.',
    allYourPhotoText: 'Все ваши сохраненные фотографии в одном месте.',
    searchGalleryText: 'Поиск и фильтрация по типу палитры, маскам или папкам.',
    storedText: 'Надежное хранение данных осуществляется через Firebase',
    canInstall: 'Вы можете установить это приложение на свой телефон или компьютер как',
    detailInstructions: 'Для подробных инструкций перейдите в раздел',
    FAQ: 'FAQ',
    faqLead: 'Установите Rainbow Manager на телефон как обычное приложение.',
    installPWATitle: 'Установка приложения как PWA',
    howInstallIOSTitle: 'Как установить приложение на iOS?',
    howInstallAndroidTitle: 'Как установить приложение на Android?',
    openAppInBrowserTitle: 'Откройте приложение в браузере',
    pressBtnTitle: 'Нажмите на кнопку',
    selectItem: 'Выберите пункт',
    squareIconTitle: 'иконка квадрата со стрелкой вверх',
    confirmAndClickTitle: 'Подтвердите название и нажмите',
    appWillAppearText:
      'Теперь иконка приложения появится на главном экране, как обычное приложение.',
    threeDotsText: 'три точки в правом верхнем углу',
    addToHomeScreenTitle: 'Добавить на главный экран',
    addToHomeScreenIosTitle: 'Добавить на экран Домой',
    addTitle: 'Установить',
    contacts: 'Контакты',
    contactsLead: 'Напишите, если есть идея, вопрос или нужна помощь с приложением.',
    ideaAndSuggestions: 'Идеи и предложения',
    supportAndAssistance: 'Поддержка и помощь',
    privacyPolicy: 'Политика конфиденциальности',
    termsOfService: 'Условия использования',
    legalAgreeLead: 'Регистрируясь, вы принимаете',
    legalAgreeAnd: 'и',
    accountDeleteTitle: 'Удаление аккаунта',
    accountDeleteIntro:
      'Здесь можно удалить аккаунт Rainbow Manager вместе со всеми данными. То же самое доступно в мобильном приложении в разделе «Аккаунт».',
    accountDeleteWhatTitle: 'Что удаляется',
    accountDeleteWhatProfile: 'Профиль и данные для входа',
    accountDeleteWhatGallery: 'Фотографии, папки, палитры и лукбуки вместе с файлами',
    accountDeleteWhatChats: 'Переписка с AI вместе с приложенными и сгенерированными изображениями',
    accountDeleteWhatUsage:
      'Счётчики использования, записи о покупках и история обращений по аккаунту',
    accountDeleteKeepTitle: 'Что остаётся',
    accountDeleteKeepStore:
      'Удаление аккаунта не отменяет подписку, купленную в Google Play или App Store. Отмените её в магазине, иначе списания продолжатся. Чеки об оплате хранит магазин, а не мы.',
    accountDeleteSignedInAs: 'Вход выполнен: {email}',
    accountDeleteAction: 'Удалить аккаунт',
    accountDeleteConfirmQuestion: 'Удалить аккаунт и все его данные? Отменить это будет нельзя.',
    accountDeleteConfirmAction: 'Да, удалить',
    accountDeleteCancel: 'Отмена',
    accountDeleteSignInFirst: 'Войдите в аккаунт, который нужно удалить.',
    accountDeleteSignIn: 'Войти',
    accountDeleteDoneTitle: 'Аккаунт удалён',
    accountDeleteDoneText:
      'Аккаунт и его данные удалены. Если у вас была подписка, отмените её в магазине.',
    accountDeleteError: 'Не удалось удалить аккаунт. Попробуйте ещё раз или напишите в поддержку.',
    accountDeleteNoAccessTitle: 'Не получается войти?',
    accountDeleteNoAccessText:
      'Напишите на {email} с адреса, на который оформлен аккаунт. Мы отвечаем на адрес, указанный в аккаунте, и удаляем только после вашего подтверждения — поэтому заявка с чужим адресом ни к чему не приведёт.',
    resetPassword: 'Сбросить пароль',
    forgotLead: 'Укажите почту, и мы отправим ссылку для сброса пароля.',
    send: 'Отправить',
    goBack: 'Назад',
    passwordResetEmailSent: 'Письмо для сброса пароля отправлено',
    registrationSuccessful: 'Регистрация прошла успешно!',
    nextStep: 'Следующий шаг',
    characteristicColors: 'Характеристики цвета',
    paletteDeterminant: 'Определитель палитры',
    settings: 'Настройки',
    fullFill: 'Полная палитра',
    showOnlySoft: 'Показывать только мягкие',
    showOnlyBright: 'Показывать только яркие',
    showOnlyCold: 'Показывать только холодные',
    showOnlyWarm: 'Показывать только теплые',
    showOnlyLight: 'Показывать только светлые',
    showOnlyDark: 'Показывать только темные',
    pleaseSelectAtLeastOneCharacteristic: 'Выберите хотя бы одну характерестику!',
    filter: 'Фильтр',
    myPalette: 'Моя палитра',
    numberOfSegments: 'Количество сегментов',
    consultation: 'Консультация',
    close: 'Закрыть',
    revealYourInherentElegance: 'Раскройте свою природную красоту',
    haveYouEverContemplated: 'Вы когда-нибудь задумывались,',
    whyCertainHues:
      'почему некоторые оттенки заставляют вас сиять, а другие, наоборот, делают незаметной? ',
    greedy:
      'Меня зовут Юлия и я знаю, что у каждого из нас есть своя уникальная цветовая палитра, данная природой, которая способна раскрыть нашу естественную красоту и придать уверенности.',
    myGoal: 'Моя цель – помочь вам найти эту палитру с помощью анализа цветотипа внешности!',
    whatWilGain: 'Что вы получите, определив свой цветотип?',
    recoveredTime: 'Сэкономленное время и деньги',
    youWillCeaseAcquiring: 'Вы перестанете покупать вещи, которые потом пылятся в шкафу.',
    assuredSelection: 'Уверенность в выборе',
    youWillPossessPreciseClarity:
      'Вы будете точно знать, какие оттенки выбирать в магазинах, при подборе макияжа или окрашивании волос.',
    cohesiveHarmonious: 'Целостный и гармоничный образ',
    youWillAppearMore:
      'Вы будете выглядеть более свежо и выразительно. Все ваши вещи будут сочетаться друг с другом.',
    bidFarewell: 'Забудьте о компромиссах и бесконечных экспериментах!',
    togetherWeWillDiscover: 'Вместе мы найдем те цвета, которые будут работать на вас!',
    connectViaTelegram: 'Написать в телеграм',
    demoLookbook: 'Демо цветотип',
    remainingInquiries: 'Остались вопросы? Закажите консультацию!',
    loginSuccessful: 'Вход выполнен успешно!',
    loginWithGoogle: 'Вход через Google',
    popupClosedByUser: 'Попап закрыт пользователем',
    cancelled: 'Отмена',
    noResults: 'По вашему запросу ничего не найдено!',
    galleryEmpty:
      'Пространство вашей галереи пока пустует — но оно готово стать холстом для ваших идей.Начните сохранять свои фотографии в галерею, и перед вами откроется инструмент для создания коллажей: соединяйте моменты, играйте с формами, оживляйте воспоминания в новых визуальных нарративах.',
    maximumSelectedCollage: 'В коллаж можно выбрать максимум 6 фотографий!',
    noFolders: 'Папки ещё не созданы!',
    reCAPTCHAInitializationError: 'Ошибка инициализации reCAPTCHA',
    reCAPTCHAHasExpired: 'reCAPTCHA истекла. Пожалуйста, пройдите проверку снова.',
    linkCopied: 'Ссылка скопирована!',
    copyError: 'Ошибка копирования!',
    colorCopied: 'Цвет скопирован!',
    mainColor: 'Основной цвет',
    save: 'Сохранить',
    successPaletteTemplateCreate: 'Шаблон успешно сохранен!',
    addTemplate: 'Добавить шаблон',
    successUpdatePaletteTemplate: 'Шаблон успешно обновлен!',
    successDeletePaletteTemplate: 'Шаблон успешно удален!',
    template: 'Шаблон',
    myTemplates: 'Мои шаблоны',
    resetTemplate: 'Сбросить шаблон',
    updateTemplate: 'Обновить шаблон',
    analysisByPhoto: 'Анализ по фото',
    saveChanges: 'Сохранить изменения',
    reset: 'Сбросить',
    next: 'Далее',
    selectTopColors: 'Пожалуйста, выберите верхние цвета',
    selectOneColor: 'Пожалуйста, выберите хотя бы один цвет!',
    shapeOfElements: 'Форма элементов',
    transformation: 'Трансформация',
    shadowSettings: 'Настройки тени',
    enableShadow: 'Включить тень',
    intensity: 'Интенсивность',
    yOffset: 'Смещение по Y',
    transparency: 'Прозрачность',
    arrangementElements: 'Расположение элементов',
    columns: 'Колонок',
    rows: 'Рядов',
    autoSelection: 'Авто подбор',
    auto: 'Авто',
    colors: 'Цветов',
    of: 'из',
    grid: 'Сетка',
    sizingSettings: 'Настройка размеров',
    elementSize: 'Размер элементов',
    spaceBetweenElements: 'Отступ между элементами',
    cutPalette: 'Вырезать цвета',
    pickColor: 'Выбрать цвет',
  },
};

export const i18n = createI18n({
  locale: 'en', // язык по умолчанию
  fallbackLocale: 'ru', // запасной язык
  messages,
});
